import { ASSET_TYPE } from '@src/components/scene/react-three-components/sceneAsset';

export const isAssetExcluded = (assetURL: string): boolean => {
  const excludedPrefixes = [
    'https://assets2022.s3.us-east-1.amazonaws.com/Dragon/RPG/3dModels',
  ];

  return excludedPrefixes.some((prefix) => assetURL.startsWith(prefix));
};

export const getAssetType = (fileType: string) => {
  switch (fileType) {
    case 'IMAGE':
      return ASSET_TYPE.PRIMITIVE_TEXTURE.IMAGE_PLANE;
    case 'AUDIO':
      return ASSET_TYPE.MISC.POSITIONAL_AUDIO;
    case 'VIDEO':
      return ASSET_TYPE.PRIMITIVE_TEXTURE.VIDEO_PLANE;
    default:
      return ASSET_TYPE.GLTF.OTHER;
  }
};
